import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import farmerInField from "../../assets/images/png/farmerinField.png";

const FranchiseIntroduction = () => {
  return (
    <div className="bg-white py-5">
      <Container>
        <Row className="align-items-center">
          <Col lg={6}>
            <div className="text-center">
              <img className="w-100" src={farmerInField} alt="" />
            </div>
          </Col>
          <Col className="ps-lg-4" lg={6}>
            <div className="mt-4 mt-lg-0">
              <h2 className="mb-0 ff_heebo fw-bold fs_6xl_2">
                Franchise <span className="clr_dark_green"> Introduction</span>
              </h2>
              <p className="mb-0 text-dark-grey ff_heebo fs_md mt-2">
                <span className="fw-bold">
                  Farmer City International Pvt Ltd (FC)
                </span>{" "}
                is a subsidiary of AVPL International, dedicated to empowering
                farmers and enhancing economic opportunities through a unique
                phygital model that integrates physical stores with digital
                platforms. As an aggregator of agri-tech startups, FC aims to
                transform Indian agriculture by providing farmers with training,
                certification, market linkages, and a wide range of agricultural
                services and products.
              </p>
              <p className="mb-0 text-dark-grey ff_heebo fs_md mt-3">
                Our franchise model involves setting up self-owned and franchise
                stores across key farming regions, serving as experience centers
                where farmers can receive training, access agricultural inputs.
                These stores will also function as hubs for our digital
                marketplace, connecting farmers with suppliers and buyers.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FranchiseIntroduction;
